import React from "react";
import Modal from "../../../Common/Modal/Modal";
import ManageCertificateModalForm from "./ManageCertificateModalForm";
import { FormattedMessage } from "react-intl";

const ManageCertificateModal = ({
  isManageCertificateModal,
  handleManageCertificateModal,
  certificateData,
  handleSearchQuery,
}) => {
  return (
    <Modal
      isOpen={isManageCertificateModal}
      heading={<FormattedMessage id="Cert_Upload" />}
      toggle={() => handleManageCertificateModal(0)}
      width={"53.4"}
      height={"36.7"}
      justifyContent="normal"
    >
      <ManageCertificateModalForm
        certificateData={certificateData}
        handleManageCertificateModal={handleManageCertificateModal}
        handleSearchQuery={handleSearchQuery}
      ></ManageCertificateModalForm>
    </Modal>
  );
};

export default ManageCertificateModal;
